__turbopack_context__.v({
  "description": "dealTile-module-scss-module__6VBp1W__description",
  "fallbackContainer": "dealTile-module-scss-module__6VBp1W__fallbackContainer",
});
